"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultState = {
  name: '',
  email: '',
  subject: '',
  message: '',
  messageSuccess: false
};

var ContactForm = /*#__PURE__*/function (_React$Component) {
  _inherits(ContactForm, _React$Component);

  var _super = _createSuper(ContactForm);

  function ContactForm(props) {
    var _this;

    _classCallCheck(this, ContactForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "resetState", function () {
      _this.setState(_objectSpread({}, defaultState));
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event) {
      var target = event.target;
      var value = target.value;
      var name = target.name;

      _this.setState(_objectSpread(_defineProperty({}, name, value), _this.state.messageSuccess && {
        messageSuccess: false
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      event.preventDefault();

      _axios["default"].post(_this.props.url, _objectSpread({
        name: _this.state.name,
        email: _this.state.email,
        subject: _this.state.subject,
        message: _this.state.message
      }, _this.props.receiver && {
        receiver: _this.props.receiver
      })).then(function (res) {
        _this.resetState();

        _this.setState({
          messageSuccess: true
        });
      })["catch"](function (err) {
        alert('Your message could not be delivered, please try again later');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var isSubmitDisabled = _this.state.name === '' || _this.state.email === '' || _this.state.subject === '' || _this.state.message === '';
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: _this.handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "name"
      }, "Name"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        name: "name",
        id: "name",
        value: _this.state.name,
        onChange: _this.handleInputChange,
        className: "form-control",
        placeholder: "Enter your name",
        required: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "email"
      }, "Email"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "email",
        name: "email",
        id: "email",
        value: _this.state.email,
        onChange: _this.handleInputChange,
        className: "form-control",
        placeholder: "Enter your email address",
        required: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "subject"
      }, "Subject"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        name: "subject",
        id: "subject",
        value: _this.state.subject,
        onChange: _this.handleInputChange,
        className: "form-control",
        placeholder: "Enter the subject of your message",
        required: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "message"
      }, "Message"), /*#__PURE__*/_react["default"].createElement("textarea", {
        name: "message",
        id: "message",
        value: _this.state.message,
        onChange: _this.handleInputChange,
        className: "form-control",
        placeholder: "Enter your message",
        required: true
      })), /*#__PURE__*/_react["default"].createElement("button", {
        type: "submit",
        className: "btn btn-secondary",
        disabled: isSubmitDisabled
      }, "Send"), _this.state.messageSuccess && /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-success mt-2"
      }, "Your message has been received"));
    });

    _this.state = _objectSpread({}, defaultState);
    return _this;
  }

  return ContactForm;
}(_react["default"].Component);

var _default = ContactForm;
exports["default"] = _default;